import { AppBar, Toolbar } from 'ui';

export const HEADER_HEIGHT = 8;

export const Header = ({ children }: { children: React.ReactNode }) => {
  return (
    <AppBar
      sx={(theme) => ({
        height: theme.spacing(HEADER_HEIGHT),
        position: 'fixed',
      })}
    >
      <Toolbar
        sx={{
          alignItems: 'center',
          display: 'flex',
          gap: 2,
          height: '100%',
          justifyContent: 'space-between',
          margin: '0 auto',
          position: 'relative',
          width: '100%',
        }}
      >
        {children}
      </Toolbar>
    </AppBar>
  );
};
